import store from "@/app/app-state";

const Middlewares = {
    authByToken(to, from, next) {
        if (!store.getters.IS_LOGGED_IN && to.query.token) {
            store
                .dispatch("AUTH_BY_TOKEN", to.query.token)
                .then(() => {
                    next(undefined);
                })
                .catch(() => {
                    next("/login");
                });
        } else {
            next(undefined);
        }
    },
    authByApiKey(to, from, next) {
        if (!store.getters.IS_LOGGED_IN && to.query.api_key) {
            store
                .dispatch("AUTH_BY_API_KEY", to.query.api_key)
                .then(() => {
                    next(undefined);
                })
                .catch(() => {
                    next("/login");
                });
        } else {
            next(undefined);
        }
    },
    authRequired(to, from, next) {
        const route = store.getters.IS_LOGGED_IN ? undefined : "/login";
        next(route);
    },
    unAuthRequired(to, from, next) {
        const route = !store.getters.IS_LOGGED_IN ? undefined : "/panel";
        next(route);
    },
    adminAccess(to, from, next) {
        const route = store.getters.IS_ADMIN ? undefined : "/404";
        next(route);
    },
    clientAccess(to, from, next) {
        const route = store.getters.IS_CLIENT ? undefined : "/404";
        next(route);
    },
    autoReg(to, from, next) {
        store
            .dispatch("AUTO_REGISTER", to.query)
            .then(() => {
                const source = store.getters.GET_UTM.utm_source;
                sessionStorage.setItem("source", source);
                // Костыль уровня интернета
                next(
                    `${"/panel/offers" + "?" + "api_key="}${localStorage.getItem("api_key")}&` +
                        `source=${source}`
                );
            })
            .catch(() => {
                next("/login");
            });
    },
    userCredentionalsRequired(to, from, next) {
        const user = store.getters.GET_REGISTRATED_USER;
        const apiKey = store.getters.GET_REGISTRATED_USER_APIKEY;

        if (user) {
            next(undefined);
        }

        if (apiKey) {
            store
                .dispatch("GET_USER_CREDENTIALS_BY_APIKEY", apiKey)
                .then(() => {
                    next(undefined);
                })
                .catch(() => {
                    next("/registration");
                });
        } else {
            next("/registration");
        }
    },

    registrationNotComplete(to, from, next) {
        const apiKey = to.query.api_key;
        const user = store.getters.GET_REGISTRATED_USER;

        if (!apiKey) {
            next("/registration");
            return;
        }
        if (user) {
            next(undefined);
            return;
        }
        if (!store.getters.IS_LOGGED_IN && apiKey) {
            store
                .dispatch("CREDENTIALS_BY_API_KEY", apiKey)
                .then((user) => {
                    if (user.registration_complete) {
                        store.dispatch("SET_AUTH_USER", user);
                        next("/panel/offers");
                    } else {
                        store.dispatch("SET_AUTH_TO_CREDENTIALS", user);
                        next(undefined);
                    }
                })
                .catch(() => {
                    next("/login");
                });
        } else {
            next(undefined);
        }
    },
};

export { Middlewares };
